import { GridApi } from '@ag-grid-community/core'
import { Injectable } from '@angular/core'
import { ColumnFilterModel } from '../../models/filter-editor.model'
import { getAggInfoAwareColumnFilterModels } from '../../utils/agg-info-filter-utils'
import { FilterModalService } from '../filter-modal-service/filter-modal.service'

/**
 * {@link FilterModalService} for a grid with AGGREGATE_INFO columns (PVAL-26423).
 *
 * Identical to the base service except for the two things that have to move together: WHICH
 * column-filter builder it uses (the override-aware one, so a column whose comparison type the user
 * owns still appears in the Filters modal — the base builder cannot type such a column and drops it —
 * and carries the operators for the chosen type), and whether the modal is allowed to RENDER the type
 * picker for those columns. Both are opt-in here so no other consumer of the base service sees either.
 *
 * Lives here rather than inside a panel, and is named for the capability rather than the panel,
 * because both positions-2 and (next) transactions-2 need exactly this — a subclass each would be two
 * copies of the same few lines. Provide it in place of `FilterModalService` at the grid component:
 *
 * ```ts
 * providers: [{ provide: FilterModalService, useClass: AggInfoFilterModalService }]
 * ```
 *
 * Not `providedIn: 'root'` — like the base service this is deliberately grid-scoped, because each
 * grid registers its own ag-Grid instance with it.
 *
 * (No `override` modifier: this repo is on TypeScript 4.2, which predates the keyword.)
 */
@Injectable()
export class AggInfoFilterModalService extends FilterModalService {
  protected buildColumnFilters(): ColumnFilterModel[] {
    return getAggInfoAwareColumnFilterModels(this.gridApi as GridApi, {
      omitColumns: this.omitColumns,
    })
  }

  protected get columnTypeOverrideEnabled(): boolean {
    return true
  }
}
